import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getMappedBusinessReviewForm } from "containers/creditReview/details/tabs/executiveSummary/sections/businessReview/getMappedBusinessReviewForm";
import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateBusinessReviewMutation = ({ creditReviewId, onSuccess }) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
			setActionFormState,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: any;
		}) => {
			return creditReviewDetailsService.updateBusinessReview(
				creditReviewId,
				getMappedBusinessReviewForm(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				onSuccess();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateBusinessReviewMutation;
